import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _obj;
/* import __COLOCATED_TEMPLATE__ from './group-manage-save-button.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { action } from "@ember/object";
import { or } from "@ember/object/computed";
import { service } from "@ember/service";
import GroupDefaultNotificationsModal from "discourse/components/modal/group-default-notifications";
import { popupAutomaticMembershipAlert } from "discourse/controllers/groups-new";
import { popupAjaxError } from "discourse/lib/ajax-error";
import discourseComputed from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./group-manage-save-button.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend((_dec = discourseComputed("saving"), _dec2 = discourseComputed("model.visibility_level", "model.primary_group", "hasFlair"), (_obj = {
  modal: service(),
  saving: null,
  disabled: false,
  updateExistingUsers: null,
  hasFlair: or("model.flair_icon", "model.flair_upload_id"),
  savingText(saving) {
    return saving ? I18n.t("saving") : I18n.t("save");
  },
  privateGroupNameNotice(visibilityLevel, isPrimaryGroup, hasFlair) {
    if (visibilityLevel === 0) {
      return;
    }
    if (isPrimaryGroup) {
      return I18n.t("admin.groups.manage.alert.primary_group", {
        group_name: this.model.name
      });
    } else if (hasFlair) {
      return I18n.t("admin.groups.manage.alert.flair_group", {
        group_name: this.model.name
      });
    }
  },
  setUpdateExistingUsers(value) {
    this.updateExistingUsers = value;
  },
  save() {
    if (this.beforeSave) {
      this.beforeSave();
    }
    this.set("saving", true);
    const group = this.model;
    popupAutomaticMembershipAlert(group.id, group.automatic_membership_email_domains);
    const opts = {};
    if (this.updateExistingUsers !== null) {
      opts.update_existing_users = this.updateExistingUsers;
    }
    return group.save(opts).then(() => {
      this.setProperties({
        saved: true,
        updateExistingUsers: null
      });
      if (this.afterSave) {
        this.afterSave();
      }
    }).catch(error => {
      const json = error.jqXHR.responseJSON;
      if (error.jqXHR.status === 422 && json.user_count) {
        this.editGroupNotifications(json);
      } else {
        popupAjaxError(error);
      }
    }).finally(() => this.set("saving", false));
  },
  async editGroupNotifications(json) {
    await this.modal.show(GroupDefaultNotificationsModal, {
      model: {
        count: json.user_count,
        setUpdateExistingUsers: this.setUpdateExistingUsers
      }
    });
    this.save();
  }
}, (_applyDecoratedDescriptor(_obj, "savingText", [_dec], Object.getOwnPropertyDescriptor(_obj, "savingText"), _obj), _applyDecoratedDescriptor(_obj, "privateGroupNameNotice", [_dec2], Object.getOwnPropertyDescriptor(_obj, "privateGroupNameNotice"), _obj), _applyDecoratedDescriptor(_obj, "setUpdateExistingUsers", [action], Object.getOwnPropertyDescriptor(_obj, "setUpdateExistingUsers"), _obj), _applyDecoratedDescriptor(_obj, "save", [action], Object.getOwnPropertyDescriptor(_obj, "save"), _obj), _applyDecoratedDescriptor(_obj, "editGroupNotifications", [action], Object.getOwnPropertyDescriptor(_obj, "editGroupNotifications"), _obj)), _obj))));